import React, { useEffect, useState } from 'react';

import { Row, Col, Flex, LoadingDots } from '@app/ui';
import unsubscribe from './unsubscribeUser';

const Unsubscribe = () => {
    const [isLoading, setLoading] = useState(true);
    const [isUnsubscribed, setUnsubscribed] = useState(false);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get('token');

        if (!token) return;
        (async () => {
            const res = await unsubscribe({ token });
            if (res) setUnsubscribed(res);
            setLoading(false);
        })();
    }, []);

    return (
        <Flex vertical className="gds-layout__container -m-a-1">
            <Row gutter={16}>
                <Col sm={24}>{isLoading && <LoadingDots />}</Col>
                <Col sm={24}>
                    {!isLoading && isUnsubscribed && (
                        <p>
                            Successfully unsubscribed from notifications. Please
                            reach out to your Customer Success Manager to
                            resubscribe to updates
                        </p>
                    )}
                    {!isLoading && !isUnsubscribed && (
                        <p>
                            An error occured. User not unsubscribed. Please
                            contact your Customer Success Manager.
                        </p>
                    )}
                </Col>
            </Row>
        </Flex>
    );
};

export default Unsubscribe;
